<div class="card mt-4 mb-4 mb-xxl-10">
    <div class="card-header">
        <div class="card-title">
            <h3>{{ isCreateBranch() ? 'Add New Branch' : branchTitle() }}</h3>
        </div>
    </div>
    <div class="card-body px-0 py-0">
        <mat-tab-group (selectedIndexChange)="onTabChange($event)">
            <mat-tab>
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Branch Details</h3>
                </ng-template>
                @if (selectedTab() === 0) {
                    <app-branch-details [branchDetailsForm]="branchForm" [branchId]="this.branchId()" [isCreateBranch]="isCreateBranch()" (countryChange)="onCountryChange($event)"  (branchDetailsSubmitEmitter)="onBranchDetailsSubmit($event)" [extractRawPhoneNumber]="extractRawPhoneNumber.bind(this)" (isAdminCompany)="onAdminCompanySelected($event)"  (countryIdChange)="onCountryIdChange($event)"></app-branch-details>
                }
            </mat-tab>
            <mat-tab [disabled]="this.isCreateBranch()">
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Contact Person Details</h3>
                </ng-template>
                @if (selectedTab() === 1) {
                    <app-branch-contact-details [branchContactForm]="branchContactForm" [isCreateBranch]="isCreateBranch()"  [extractRawPhoneNumber]="extractRawPhoneNumber.bind(this)" (branchContactDetailsSubmitEmitter)="onBranchContactDetailsSubmit($event)" [countryId]="countryIdSignal()"></app-branch-contact-details>
                }
            </mat-tab>
            @if(!isAdminCompanySelected()){
            <mat-tab [disabled]="this.isCreateBranch()">
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Lloyd's Details</h3>
                </ng-template>
                @if (selectedTab() === 2) {
                    <app-branch-llyod-details [branchLlyodForm]="branchLlyodForm" [isCreateBranch]="isCreateBranch()" (branchllyodDetailsSubmitEmitter)="onBranchllyodDetailsSubmit($event)" [countryId]="countryIdSignal()"></app-branch-llyod-details>
                }
            </mat-tab>
        }
        </mat-tab-group>
    </div>
</div>